import React, {useState, useRef, useEffect} from "react";
import Header from "../../components/Header";

import {useNavigate} from "react-router-dom";
import {useTranslation} from "react-i18next";
import Button from "../../components/Button";
import Loader from "../../components/Loader";
import {
  checkContentAvlInArray,
  // dataDashboard
} from "../../util";
import FormPanel from "../../components/FormPanel";
import {
  validateEmail,
  validateName,
  validateTel,
  validateFormInput,
  removeEverySpace,
  validateminLength,
} from "../../services/Validator";
import {
  setCustomerSlotDetails,
  getCustomerSlotDetails,
} from "../../services/SessionStorage";
import {
  CUSTOMER_ID_SESSION_KEY,
  CUSTOMER_EMAIL_SESSION_KEY,
  CUSTOMER_TEL_SESSION_KEY,
  CUSTOMER_NAME_SESSION_KEY,
  DEFAULT_CUSTOMER_ID_LABEL,
  ADOBEDTM_PAGE_NAME,
} from "../../constants";
import "./style.scss";
import "../../components/Loader/style.scss";
import {StepperWrapper} from "../../components/StepperWrapper";
import config from "config";

const AdditionalData = () => {
  const {t} = useTranslation();
  const navigate = useRef(useNavigate());
  const customerSlotDetails = getCustomerSlotDetails();

  const loginFormModel = [];
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const textLabel = useRef("");
  const loadingText = useRef("");
  const prepareLoginFormModel = () => {
    textLabel.current = t("curp.label");
    {
      loginFormModel.push({
        name: "userId",
        label: DEFAULT_CUSTOMER_ID_LABEL,
        placeholder: t("inputname.placeholder"),
        type: "text",
        disableItem: true,
        value: customerSlotDetails[CUSTOMER_ID_SESSION_KEY],
      });
      loginFormModel.push({
        name: "username",
        label: t("inputname.label"),
        placeholder: t("inputname.placeholder"),
        type: "text",
        value: customerSlotDetails[CUSTOMER_NAME_SESSION_KEY]
          ? customerSlotDetails[CUSTOMER_NAME_SESSION_KEY]
          : "",
        validators: [
          {
            id: "name-pattern",
            isValid: validateName,
            alert: t("name.invalid.error"),
          },
          {
            id: "name-required",
            isValid: validateFormInput.checkIsfilled,
            alert: t("name.empty.error"),
          },
        ],
      });
      if (customerSlotDetails) {
        loginFormModel.push({
          name: "userTel",
          label: t("inputtel.label"),
          placeholder: t("inputtel.placeholder"),
          type: "text",
          parser: removeEverySpace,
          defaultInput: customerSlotDetails.storeStoreData
            ? customerSlotDetails.storeStoreData.selectedStore.callCode
            : customerSlotDetails.currentBookingDetails.selectedStore.callCode
            ? customerSlotDetails.currentBookingDetails.selectedStore.callCode
            : "",
          value: customerSlotDetails[CUSTOMER_TEL_SESSION_KEY]
            ? customerSlotDetails[CUSTOMER_TEL_SESSION_KEY].substring(2)
            : "",
          maxlengthValue: config.phoneLength[customerSlotDetails.country]
            ? config.phoneLength[customerSlotDetails.country].max
            : 10,
          validators: [
            {
              id: "tel-pattern",
              isValid: validateTel,
              alert: t("tel.invalid.error"),
            },
            {
              id: "tel-required",
              isValid: validateFormInput.checkIsfilled,
              alert: t("tel.empty.error"),
            },
            {
              id: "tel-minlength",
              isValid: validateminLength,
              alert:
                t("tel.minlength.error") +
                (config.phoneLength[customerSlotDetails.country]
                  ? config.phoneLength[customerSlotDetails.country].min
                  : " > 4"),
            },
          ],
        });
      }
      loginFormModel.push({
        name: "email",
        label: t("inputemail.label"),
        placeholder: t("inputemail.placeholder"),
        type: "text",
        parser: removeEverySpace,
        value: customerSlotDetails[CUSTOMER_EMAIL_SESSION_KEY]
          ? customerSlotDetails[CUSTOMER_EMAIL_SESSION_KEY]
          : "",
        validators: [
          {
            id: "email-pattern",
            isValid: validateEmail,
            alert: t("email.invalid.error"),
          },
          {
            id: "email-required",
            isValid: validateFormInput.checkIsfilled,
            alert: t("email.empty.error"),
          },
        ],
      });
      let validationArray = {};
      if (
        customerSlotDetails.currentBookingDetails.bu === config.showNoonSlotsBU
      ) {
        let buNameWithoutSpace = customerSlotDetails.source.split("_")[0];
        loadingText.current = t("loading.text");
        let linksdata = {};
        linksdata.beforeText = t(
          `tnc.label.${buNameWithoutSpace}.${customerSlotDetails.country}.beforeText`
        );
        linksdata.linkText = t(
          `tnc.label.${buNameWithoutSpace}.${customerSlotDetails.country}.linkText`
        );
        linksdata.linkUrl = customerSlotDetails.storeStoreData
          ? customerSlotDetails.storeStoreData.selectedStore.termsCondition
          : customerSlotDetails.currentBookingDetails.selectedStore
              .termsCondition;

        validationArray = {
          id: "acceptance-required",
          isValid: validateFormInput.checkIsTrue,
          alert:
            t("tnc.empty.error") +
            t(
              `tnc.label.${buNameWithoutSpace}.${customerSlotDetails.country}.linkText`
            ),
        };
        loginFormModel.push({
          name: "iagreeterms",
          linksdata: linksdata,
          type: "checkbox",
          addditionaldata: [],
          validators: [validationArray],
        });
      }
      if (
        checkContentAvlInArray(
          config.stand_alone_bu_list,
          customerSlotDetails.buList
        )
      ) {
        loadingText.current = t("loading.text");
        let linksdata = {};
        linksdata.beforeText = t(
          `tnc.label.${customerSlotDetails.buList[0]}.${customerSlotDetails.country}.beforeText`
        );
        linksdata.linkText = t(
          `tnc.label.${customerSlotDetails.buList[0]}.${customerSlotDetails.country}.linkText`
        );
        linksdata.linkUrl = customerSlotDetails.storeStoreData
          ? customerSlotDetails.storeStoreData.selectedStore.termsCondition
          : customerSlotDetails.currentBookingDetails.selectedStore
              .termsCondition;
        if (
          !(
            customerSlotDetails.buList[0] === "Openplaza" &&
            customerSlotDetails.country === "CL"
          )
        ) {
          validationArray = {
            id: "acceptance-required",
            isValid: validateFormInput.checkIsTrue,
            alert:
              t("tnc.empty.error") +
              t(
                `tnc.label.${customerSlotDetails.buList[0]}.${customerSlotDetails.country}.linkText`
              ),
          };
          loginFormModel.push({
            name: "iagreeterms",
            linksdata: linksdata,
            type: "checkbox",
            addditionaldata: [],
            validators: [validationArray],
          });
        }
        if (
          customerSlotDetails.storeStoreData.selectedStore
            .termsConditionsAdditional &&
          customerSlotDetails.storeStoreData.selectedStore
            .termsConditionsAdditional.length > 0
        ) {
          let linksdata = {};
          linksdata.beforeText = t(
            `tnc.label.${customerSlotDetails.buList[0]}.${customerSlotDetails.country}.additional0.beforeText`
          );
          linksdata.linkText = t(
            `tnc.label.${customerSlotDetails.buList[0]}.${customerSlotDetails.country}.additional0.linkText`
          );
          linksdata.linkUrl =
            customerSlotDetails.storeStoreData.selectedStore.termsConditionsAdditional[0];
          let addditionaldata = [];
          let allAddditionaldata = [];
          for (
            let i = 1;
            i <
            customerSlotDetails.storeStoreData.selectedStore
              .termsConditionsAdditional.length;
            i++
          ) {
            addditionaldata.push(
              t(
                `tnc.label.${customerSlotDetails.buList[0]}.${customerSlotDetails.country}.additional${i}.beforeText`
              )
            );
            addditionaldata.push(
              t(
                `tnc.label.${customerSlotDetails.buList[0]}.${customerSlotDetails.country}.additional${i}.linkText`
              )
            );
            addditionaldata.push(
              customerSlotDetails.storeStoreData.selectedStore
                .termsConditionsAdditional[i]
            );
            allAddditionaldata.push(addditionaldata);
            addditionaldata = [];
          }
          if (
            !(
              customerSlotDetails.buList[0] === "Openplaza" &&
              customerSlotDetails.country === "CL"
            )
          ) {
            loginFormModel.push({
              name: "iagreeadditionalterms",
              linksdata: linksdata,
              type: "checkbox",
              defaultChecked:
                customerSlotDetails.buList[0] === "Mallplaza" &&
                customerSlotDetails.country === "CL"
                  ? true
                  : false,
              addditionaldata: allAddditionaldata,
            });
          }
        }
      } else {
        loadingText.current = t("banco.loading.text");
      }
    }
  };
  prepareLoginFormModel();
  const submitCallback = (e) => {
    setLoading(true);
    let sessionData = {};
    loginFormModel.forEach((m) => {
      if (m.name === "email")
        sessionData[CUSTOMER_EMAIL_SESSION_KEY] = m.value.toLowerCase();
      if (m.name === "username")
        sessionData[CUSTOMER_NAME_SESSION_KEY] = m.value.toLowerCase();
      if (m.name === "userTel") {
        let telText = m.defaultInput + m.value;
        telText = telText.replace(/\s/g, "");
        telText = telText.substring(1);
        sessionData[CUSTOMER_TEL_SESSION_KEY] = telText;
      }
      if (m.name === "iagreeterms") {
        sessionData.acceptTermsConditions = m.value;
      }

      if (m.name === "iagreeadditionalterms") {
        if (
          customerSlotDetails.buList[0] === "Mallplaza" &&
          customerSlotDetails.country === "CL"
        ) {
          //default value will be unchecked hence made false
          sessionData.acceptUseOfMyInformation =
            m.value || m.value === undefined ? true : false;
        } else {
          sessionData.acceptUseOfMyInformation = m.value ? true : false;
        }
        sessionData.acceptReadTermsConditions = true; // This is hardcoded presently. Later it will be
        // changed if there is checkbox for read TnC
      }
      setCustomerSlotDetails({...customerSlotDetails, ...sessionData});
      return;
    });
    setTimeout(() => {
      setLoading(false);
      navigate.current("/customer/slotBooked");
    }, 3000);
  };
  const isOpenPlazaChile = () => {
    if (
      customerSlotDetails.buList[0] === "Openplaza" &&
      customerSlotDetails.country === "CL"
    ) {
      return true;
    } else {
      return false;
    }
  };

  // useEffect(() => {
  //   // for data dashboard
  //   const URL = window.location.href.split("/")[2];
  //   const officeApp = customerSlotDetails.isOffice
  //     ? URL + "/office"
  //     : URL + "/app";
  //   const datamap = new Map();
  //   datamap.set("pageName", ADOBEDTM_PAGE_NAME.CT_Additional_Data_Collection);
  //   datamap.set("prop1", URL);
  //   datamap.set("prop2", officeApp);
  //   dataDashboard(datamap);
  // }, []);

  return loading ? (
    <div className="loader-container">
      <Loader value={loadingText.current} />
    </div>
  ) : (
    <div className="additionalData-container">
      <Header title={t("login.label")} />
      <StepperWrapper current={2} />
      <h3 className="additionalData-heading">
        {t("additionalData.labelMiddleScreen")}
      </h3>
      <FormPanel
        id="control-trafico-login-form"
        submitCallback={submitCallback}
        model={loginFormModel}
      />
      {error ? (
        <div className="guestLogin-booking-error">
          {" "}
          <p>{error}</p>
        </div>
      ) : (
        ""
      )}
      <div>
        {isOpenPlazaChile() ? (
          <div className="guestLogin-MallplazaCL-TnC">
            <div className="guestLogin-MallplazaCL-TnC-spacing">
              Nuestro compromiso es cuidar tu salud. Por ello, en este acto,
              autorizas expresamente a Open Plaza Chile SPA, de conformidad al
              artículo 4° de la Ley N°19.628 sobre Protección de la Vida Privada
              (“Ley de Protección de Datos”), a tratar los datos personales que
              nos proporcionas al ingresar a nuestra Plataforma Fila Virtual.
              Tus datos personales podrán ser tratados por Openplaza y/o sus
              Empresas Relacionadas, por sí o a través de sus proveedores,
              exclusivamente para realizar control de aforo y aplicación de
              políticas sanitarias con ocasión de la pandemia por COVID-19. Los
              datos obtenidos a través del agendamiento en la Plataforma Fila
              Virtual, no podrán ser transferidos ni negociarlos y se tratarán
              con la más estricta reserva y confidencialidad.
            </div>
          </div>
        ) : (
          ""
        )}
      </div>
      <Button value={t("continue")} formId="control-trafico-login-form" />
    </div>
  );
};

export default AdditionalData;
